import React from 'react';
import './css/style.css';
import './css/video.css';
import { Link } from 'react-router-dom';
import VideoSchema from "./sub-components/VideoSchema";
import { Helmet } from 'react-helmet-async';
import videosData from '../data/json/videos.json';

// Keep these in sync with the "/Video" entry in SeoPageRenderer.cs
const PAGE_URL = "https://www.dysband.com/Video";
const PAGE_TITLE = "Live Yacht Rock Videos | Dirty Yachtin' Scoundrels";
const PAGE_DESCRIPTION =
    "Watch full video performances from Dirty Yachtin' Scoundrels, the yacht rock band bringing smooth '70s and '80s hits to life with every live show.";
const PAGE_IMAGE =
    "https://www.dysband.com/media/yacht_rock_band_dirty_yachtin_scoundrels_live.webp";

const Video = () => {
    // The videos come from a bundled JSON file, so there is nothing to wait for.
    // (The old loading state rendered "Loading videos..." with no tags on the first paint.)
    const videos = videosData;

    return (
        <section
            id="video"
            className="container-fluid video_wrap margin-bottom"
            style={{ textAlign: 'center' }}
        >
            <Helmet>
                <title>{PAGE_TITLE}</title>
                <meta name="description" content={PAGE_DESCRIPTION} />
                <link rel="canonical" href={PAGE_URL} />

                <meta property="og:title" content={PAGE_TITLE} />
                <meta property="og:description" content={PAGE_DESCRIPTION} />
                <meta property="og:url" content={PAGE_URL} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Dirty Yachtin' Scoundrels" />
                <meta property="og:image" content={PAGE_IMAGE} />
                <meta property="og:image:alt" content="Dirty Yachtin' Scoundrels performing live in video." />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={PAGE_TITLE} />
                <meta name="twitter:description" content={PAGE_DESCRIPTION} />
                <meta name="twitter:image" content={PAGE_IMAGE} />
            </Helmet>

            <VideoSchema videos={videos} />

            <h1 className="h3_light" style={{ marginTop: "1rem" }}>
                Experience Dirty Yachtin’ Scoundrels Live
            </h1>
            <p>
                Get a taste of Dirty Yachtin’ Scoundrels in action with short video clips from past live performances — from high-energy sets to smooth yacht rock classics.
            </p>
            <p>
                Dirty Yachtin' Scoundrels is a Phoenix, Arizona yacht rock band that plays weddings, corporate events, private parties, and festivals. Like what you see? Check the <Link to="/Calendar">upcoming shows</Link> or <Link to="/Contact">book the band</Link>.
            </p>
            <div className="video-cont">
                {videos.map(({ id, name, embedUrl }, idx) => (
                    <div key={id || idx} className="video" style={{ margin: '1rem' }}>
                        <div className="videos">
                            <h2>{name}</h2>
                            <iframe
                                src={embedUrl}
                                title={name}
                                frameBorder="0"
                                loading="lazy"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Video;